import React, {Fragment, useState, useEffect, useRef, useCallback} from 'react';
import { useHistory } from 'react-router-dom';
import warehouse from '../../assets/warehouse-1.jpeg';
import FileUploader from 'devextreme-react/file-uploader';
import Form, {
    Item,
    RequiredRule,
    Label,
    EmptyItem,
    ButtonItem,
    ButtonOptions
} from 'devextreme-react/form';
import { Button } from 'devextreme-react/button';
import DataSource from 'devextreme/data/data_source';
import StatesService from '../../utils/states';
import CountryService from '../../utils/country';
import ScrollView from 'devextreme-react/scroll-view';
import notify from 'devextreme/ui/notify';
import companyApi from '../../api/company';
import addressApi from '../../api/address';
import url from '../../api/base-url';
import sessions from '../../sessions';
import './welcome.scss';

export default function (props) {
    const history = useHistory();
    const [countryValue, setCountryValue] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [filePath, setFilePath] = useState('');
    const [isPreviewImage, setIsPreviewImage] = useState(false);
    const [colspanUploadImage, setColspanUploadImage] = useState(2);
    
    const formData = useRef({});
    const companyId = sessions.getSession("user")?.companyId;
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const country = new DataSource({
        store: {
            type: 'array',
            data: CountryService,
            key: 'id'
        },
        pageSize: 10,
        paginate: true
    });
    const CountryOnChange = ({value}) => {
        setCountryValue(value);
        //console.log(countryValue);
    }

    useEffect(() => {
        companyApi.getCompanyById(companyId)
            .then(res => setCompanyName(res.data.data.companyName))
    }, [companyId])

    const submitBtn = async () => {
        const { city, country, firstName, lastName, state, street1, zipCode, name } = formData.current;
        let countryName = CountryService.filter(e => e.id === country)
        let stateName = StatesService.filter(e => e.id === state)
        let dataSend = {
            userId: userId,
            companyId: companyId,
            city: city,
            country: countryName[0].iso2,
            state: stateName[0].name,
            street1: street1,
            zipCode: zipCode,
            name: name,
            firstname: firstName, 
            lastname: lastName,
            avatarUrl: filePath }
        
        await addressApi.createAddressByCompanyId(dataSend,auth)
                .then((res) => {
                    if(res.data.success === true) {
                        notify(`Updated Successfuly`, "success");
                        setTimeout(() => {
                            history.push('/dashboard/')
                        }, 2000);
                    } else {
                        notify(`Something is wrong!`, "error");
                    }
                })
    }

    const onUploaded = (e) => {
        let response = JSON.parse(e.request.response)
        let imageURL = response.data.path.replace('output/', '')
        setFilePath(imageURL)
        setColspanUploadImage(1)
        setIsPreviewImage(true)
    }
    
    const removeImageBtn = () => {
        setFilePath('')        
        setColspanUploadImage(2)
        setIsPreviewImage(false)
    }

    const state = new DataSource({
        store: {
            data: StatesService,
            type: 'array',
            key: 'id'
        },
        filter: [
            "country_id", "=", countryValue
        ],
        pageSize: 10,
        paginate: true
    });

    return (
        <ScrollView>
            <div className="welcome">
                <div className="flex flex-row">
                    <div>
                        <img className="warehouse" alt="warehouse" src={warehouse}/>
                    </div>
                    <div className={'quick-setup-form'}>
                        <h3>Quick Set Up</h3>
                        <br/>
                        <p style={{textAlign:'center'}}>{companyName}</p>
                        <br/>
                        <Form formData={formData.current} colCount={2}>
                            <Item visible={isPreviewImage}>                        
                                <img style={{width: "100%"}} alt="avatarImage" src={`${url}/${filePath}`} />
                                <br />
                                <Button onClick={removeImageBtn} width="100%" text="Remove Image" />
                            </Item>
                            <Item
                                colSpan={colspanUploadImage}
                                dataField={'avatarUrl'}
                                editorType={'dxFileUploader'}
                                editorOptions={{
                                    stylingMode: "filled",
                                    fileUploadRef: "fileUploadRef",
                                    height: 40,
                                    selectButtonText:"Select photo",
                                    labelText:"",
                                    name:"files",
                                    uploadUrl:`${url}/upload`,
                                    onUploaded: onUploaded, 
                                    accept:"image/*", 
                                }}>
                                <RequiredRule message="first name is required"/>
                                <Label text="Profile Picture"/>
                            </Item>
                            <Item
                                dataField={'firstName'}
                                editorOptions={{
                                stylingMode: "filled",
                                height: 40
                            }}>
                                <RequiredRule message="first name is required"/>
                            </Item>
                            <Item
                                dataField={'lastName'}
                                editorOptions={{
                                stylingMode: "filled",
                                height: 40
                            }}>
                                <RequiredRule message="last name is required"/>
                            </Item>
                            <Item
                                editorType={'dxSelectBox'}
                                dataField="country"
                                editorOptions={{
                                    stylingMode: "filled",
                                    height: 40,
                                    dataSource: country,
                                    searchEnabled: true,
                                    displayExpr: 'name',
                                    valueExpr: 'id',
                                    onValueChanged: CountryOnChange
                                }}>
                                <RequiredRule message="country is required" />
                                <Label text="Business Location" />
                            </Item>      
                            <Item
                                dataField="state"
                                editorType="dxSelectBox"
                                editorOptions={{
                                    stylingMode: "filled",
                                    height: 40,
                                    dataSource: state,
                                    searchEnabled: true,
                                    displayExpr: 'name',
                                    valueExpr: 'id'
                                }}>
                                <RequiredRule message="state is required" />
                            </Item>                                                  
                            <Item
                                dataField="name"
                                editorOptions={{
                                stylingMode: "filled",
                                height: 40,
                            }}>
                                <RequiredRule message="business name is required"/>
                                <Label text="Business Name"/>
                            </Item>                                                        
                            <Item
                                editorType={'dxTextBox'}
                                dataField="city"
                                editorOptions={{
                                stylingMode: "filled",
                                height: 40
                            }}>
                                <RequiredRule message="city is required"/>
                            </Item>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="zipCode"
                                editorOptions={{
                                stylingMode: "filled",
                                height: 40
                            }}>
                                <RequiredRule message="Zip Code is Required"/>
                                <Label text={'Zip Code'}/>
                            </Item>
                            <Item
                                editorType={'dxTextBox'}
                                dataField="street1"
                                editorOptions={{
                                stylingMode: "filled",
                                height: 40
                            }}>
                                <RequiredRule message="Main Address is required"/>
                                <Label text={'Main Address'}/>
                            </Item>
                            <EmptyItem/>
                            <ButtonItem colSpan={2}>
                                <ButtonOptions 
                                    onClick={submitBtn}
                                    type="default" 
                                    text={"Let'\s Get Started"} 
                                    width={'100%'}/>
                            </ButtonItem>
                        </Form>
                    </div>
                </div>
            </div>
        </ScrollView>
    )
}